import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";

const PrivacyPolicyPage = () => {
  const { t, i18n } = useTranslation();
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-in-out",
    });
  }, []);

  return (
    <>
      <section
        className="bg-light position-relative overflow-hidden"
        style={{ "--bs-bg-opacity": 0.8 }}
      >
        {/* Decorative Patterns */}
        <div
          className="position-absolute top-0 start-0 d-none d-lg-block"
          style={{ opacity: 0.07 }}
        >
          <svg width="180" height="180" viewBox="0 0 200 200">
            <path
              d="M45,0 L0,45 L45,90 L90,45 Z"
              fill="#6B72E0"
              transform="translate(0, 0)"
            ></path>
            <path
              d="M45,0 L0,45 L45,90 L90,45 Z"
              fill="#6B72E0"
              transform="translate(80, 80)"
            ></path>
          </svg>
        </div>
        <div
          className="position-absolute bottom-0 end-0 d-none d-lg-block"
          style={{ opacity: 0.07 }}
        >
          <svg width="150" height="150" viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="50" fill="#6B72E0"></circle>
            <circle cx="50" cy="50" r="35" fill="#ffffff"></circle>
            <circle cx="50" cy="50" r="20" fill="#6B72E0"></circle>
          </svg>
        </div>

        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <div
                className="d-inline-flex justify-content-center align-items-center bg-primary-custom rounded-circle mb-3"
                style={{ width: "60px", height: "60px" }}
              >
                <i className="fas fa-fingerprint fa-lg text-white"></i>
              </div>
              <h1
                className="fw-bold text-primary-custom mb-3"
                data-aos="fade-up"
              >
                {t("PrivacyPolicy.heading")}
              </h1>

              <p className="lead mb-4" data-aos="fade-up" data-aos-delay="200">
                {t("PrivacyPolicy.introduction")}
              </p>

              <div
                className="policy-info-card bg-white rounded-3 shadow-sm p-4 mb-4"
                data-aos="fade-up"
                data-aos-delay="260"
              >
                <div className="d-flex align-items-start gap-3">
                  <div
                    className="rounded-circle bg-primary-custom d-flex align-items-center justify-content-center"
                    style={{ width: 48, height: 48 }}
                  >
                    <i className="fas fa-trademark text-white"></i>
                  </div>
                  <div>
                    <h2 className="h5 mb-2">
                      {i18n.language === "ar"
                        ? "™ متحدثون علامة تجارية مسجلة"
                        : "™ Mutahadithun – Registered Trademark"}
                    </h2>
                    <p className="mb-0 text-muted">
                      {i18n.language === "ar"
                        ? "شعار وهوية متحدثون مسجّلان لدى الهيئة السعودية للملكية الفكرية. يُحظر استخدام العلامة أو تقليدها دون إذن كتابي مسبق."
                        : "The Mutahadithun logo and identity are registered with the Saudi Authority for Intellectual Property. Any use or imitation without prior written permission is prohibited."}
                    </p>
                  </div>
                </div>
              </div>

              <div className="row">
                {[1, 2, 3].map((section, index) => (
                  <div className="col-md-4 mb-4" key={section}>
                    <div
                      className="section bg-white rounded-3 shadow-sm p-3 h-100"
                      data-aos="fade-up"
                      data-aos-delay={300 + index * 100}
                    >
                      <h2 className="text-primary fs-4 fw-semibold mb-3">
                        {t(`PrivacyPolicy.section${section}.title`)}
                      </h2>
                      <p className="text-muted fs-6">
                        {t(`PrivacyPolicy.section${section}.content`)}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicyPage;
